import { NFormTable } from "../../../Shared/NewForms/NFormTable";
import { NFLookupProduct } from "../../../Shared/NewForms/NFLookupProduct";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { NFLookupAccount } from "../../../Shared/NewForms/NFLookupAccount";
import { NFLookupUnit } from "../../../Shared/NewForms/NFLookupUnit";
import { NFLookupBaseDocuments } from "../../../Shared/NewForms/NFLookupBaseDocuments";

export const ProductionAndSalesDetailMaterials = () => {
    const tableName = "products";
    const { t } = useTranslation();

    useEffect(() => {}, []);

    return (
        <>
            <NFormTable fieldArray={"materials"}>
                <NFLookupBaseDocuments
                    title={t("Item")}
                    fieldName="itemId"
                />
                <NFLookupUnit title={t("Unit")} fieldName="unitId" />
                <NFIntInput title={t("Quantity")} fieldName="quantity" />
                <NFLookupAccount title={t("Account")} fieldName="accountId" />
                <NFLookupProduct
                    title={t("Product")}
                    fieldName="productionAndSaleId"
                />
            </NFormTable>
        </>
    );
};
